module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/marketing-tout-3f2bcb795a32a37449d9217f566105d1.jpg";